import { useState, useEffect } from "react";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import Bgimage from "../assest/house-desktop3.png";
import Housecenter from "../assest/house-center.png";
import Description from "./description";
import Footer from "./footer";
import { MdKeyboardArrowUp ,MdKeyboardArrowDown } from "react-icons/md";

const allProjects = [
  {
    name: "Mr. & Mrs Rout",
    city: "Bhubaneswar",
    floor: "G+1",
    area: "30-40",
    size: "30 × 50 sq.ft",
    price: "80L-90L",
    image: Housecenter,
  },
  {
    name: "Mr. Das",
    city: "Cuttack",
    floor: "G+2",
    area: "40-50",
    size: "40 × 60 sq.ft",
    price: "70L-80L",
    image: Housecenter,
  },
  {
    name: "Mr. Sahoo",
    city: "Sambalpur",
    floor: "G+3",
    area: "50-60",
    size: "50 × 70 sq.ft",
    price: "90L-1Cr",
    image: Housecenter,
  },
  // extra data for pagination demo
  ...Array(9).fill({
    name: "Mr. Rout",
    city: "Bhubaneswar",
    floor: "G+1",
    area: "30-40",
    size: "30 × 50 sq.ft",
    price: "80L-90L",
    image: Housecenter,
  }),
];

export default function ProjectsPage() {
  const [filters, setFilters] = useState({
    city: [],
    floor: [],
    area: [],
  });
  const [open, setOpen] = useState({
    city: true,
    floor: true,
    area: true,
  });

  const toggle = (section) => {
    setOpen((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  const [filteredData, setFilteredData] = useState(allProjects);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 4;

  // HANDLE FILTER
  const handleFilter = (type, value) => {
    setFilters((prev) => {
      const exists = prev[type].includes(value);

      return {
        ...prev,
        [type]: exists
          ? prev[type].filter((v) => v !== value)
          : [...prev[type], value],
      };
    });
  };

  // AUTO FILTER
  useEffect(() => {
    let data = allProjects;

    if (filters.city.length) {
      data = data.filter((p) => filters.city.includes(p.city));
    }

    if (filters.floor.length) {
      data = data.filter((p) => filters.floor.includes(p.floor));
    }

    if (filters.area.length) {
      data = data.filter((p) => filters.area.includes(p.area));
    }

    setFilteredData(data);
    setCurrentPage(1); // reset page when filter changes
  }, [filters]);

  // PAGINATION
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  // RESET FILTER
  const resetFilter = () => {
    setFilters({ city: [], floor: [], area: [] });
    setCurrentPage(1);
  };

  const openPage = () => {
    window.location.href = "/Ourproject/description";
  };

  return (
    <div className="bg-[#f2ecf7]">
      {/* HERO */}
      <div
        className="w-full h-[220px] md:h-[280px] bg-cover bg-center"
        style={{ backgroundImage: `url(${Bgimage})` }}
      />

      {/* TITLE */}
      <h1 className="max-w-[1200px] mx-auto px-4 mt-8 mb-4 text-[28px] md:text-[36px] font-semibold">
        Our Projects
      </h1>

      <div className="max-w-[1200px] mx-auto font-poppins px-4 pb-12 flex flex-col lg:flex-row gap-8">
        {/* SIDEBAR */}
        <div className="w-full lg:w-[260px] bg-[#e9dff3] p-5 rounded-xl">
          <b>Filter</b>

          {/* Cities */}
          <div className="mt-4">
            <div
              className="flex justify-between items-center cursor-pointer"
              onClick={() => toggle("city")}
            >
              <h3 className="font-semibold text-[16px]">Cities</h3>
              <span>{open.city ? <MdKeyboardArrowUp className="text-[24px]" /> : <MdKeyboardArrowDown className="text-[24px]" />}</span>
            </div>

            {open.city && (
              <div className="mt-2">
                {[
                  "Bhubaneswar",
                  "Cuttack",
                  "Puri",
                  "Rourkela",
                  "Sambalpur",
                  "Berhampur",
                  "Balasore",
                  "Bhadrak",
                  "Baripada",
                  "Jharsuguda",
                  "Jeypore",
                  "Angul",
                  "Dhenkanal",
                  "Keonjhar",
                  "Rayagada",
                  "Paradeep",
                ].map((city) => (
                  <label key={city} className="block text-sm mt-2">
                    <input
                      type="checkbox"
                      checked={filters.city.includes(city)}
                      onChange={() => handleFilter("city", city)}
                      className="mr-2"
                    />
                    {city}
                  </label>
                ))}
              </div>
            )}
          </div>

          {/* Floors */}
          <div className="mt-4">
            <div
              className="flex justify-between items-center cursor-pointer"
              onClick={() => toggle("floor")}
            >
              <h3 className="font-semibold">Floors</h3>
              <span>{open.floor ? <MdKeyboardArrowUp className="text-[24px]" /> : <MdKeyboardArrowDown className="text-[24px]" />}</span>
            </div>

            {open.floor && (
              <div className="mt-2">
                {["G+1", "G+2", "G+3", "G+4", "G+5"].map((f) => (
                  <label key={f} className="block text-sm mt-2">
                    <input
                      type="checkbox"
                      checked={filters.floor.includes(f)}
                      onChange={() => handleFilter("floor", f)}
                      className="mr-2"
                    />
                    {f}
                  </label>
                ))}
              </div>
            )}
          </div>

          {/* Area */}
          <div className="mt-4">
            <div
              className="flex justify-between items-center cursor-pointer"
              onClick={() => toggle("area")}
            >
              <h3 className="font-semibold">Plot dimensions</h3>
              <span>{open.area ? <MdKeyboardArrowUp className="text-[24px]" /> : <MdKeyboardArrowDown className="text-[24px]" />}</span>
            </div>

            {open.area && (
              <div className="mt-2">
                {["30x40 sq.ft", "30x50 sq.ft"].map((a) => (
                  <label key={a} className="block text-sm mt-2">
                    <input
                      type="checkbox"
                      checked={filters.area.includes(a)}
                      onChange={() => handleFilter("area", a)}
                      className="mr-2"
                    />
                    {a}
                  </label>
                ))}
              </div>
            )}
          </div>

          {/* BUTTON */}
          <button
            onClick={resetFilter}
            className="mt-4 w-full py-2 bg-gray-300 rounded-lg font-medium hover:bg-gray-400 transition"
          >
            Refresh
          </button>
        </div>

        {/* GRID */}
        <div className="flex-1">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {paginatedData.length === 0 && <p>No projects found</p>}

            {paginatedData.map((item, i) => (
              <div
                key={i}
                onClick={openPage}
                className="bg-[#e9dff3] rounded-xl overflow-hidden relative cursor-pointer hover:-translate-y-1 transition"
              >
                {/* IMAGE */}
                <img
                  src={item.image}
                  alt="house"
                  className="w-full h-[180px] object-cover"
                />

                {/* ARROW */}
                <div className="absolute right-4 top-1/2 -translate-y-1/2 w-[40px] h-[40px] bg-white rounded-full flex items-center justify-center shadow">
                  <FaArrowRight className="text-[#6a4b8d]" />
                </div>

                {/* CONTENT */}
                <div className="p-4">
                  <h3 className="font-semibold">{item.name}</h3>

                  <div className="text-sm text-[#6a4b8d] flex gap-3 flex-wrap">
                    <span>📍 {item.city}</span>
                    <span>📐 {item.size}</span>
                    <span>💰 {item.price}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* PAGINATION */}
          <div className="flex justify-center items-center gap-3 mt-8">
            {/* LEFT */}
            <FaArrowLeft
              className={`cursor-pointer ${
                currentPage === 1 && "opacity-30 cursor-not-allowed"
              }`}
              onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
            />

            {/* PAGE NUMBERS */}
            {[...Array(totalPages)].map((_, i) => (
              <div
                key={i}
                onClick={() => setCurrentPage(i + 1)}
                className={`w-[32px] h-[32px] flex items-center justify-center border-2 rounded cursor-pointer text-sm ${
                  currentPage === i + 1
                    ? "bg-[#8b5cf6] text-white border-[#8b5cf6]"
                    : "border-[#8b5cf6] text-[#8b5cf6]"
                }`}
              >
                {i + 1}
              </div>
            ))}

            {/* RIGHT */}
            <FaArrowRight
              className={`cursor-pointer ${
                currentPage === totalPages && "opacity-30 cursor-not-allowed"
              }`}
              onClick={() =>
                currentPage < totalPages && setCurrentPage(currentPage + 1)
              }
            />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
